import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useCheckAuthQuery } from 'api/adminApi';

type ProtectedRouteProps = {
    children: ReactNode;
};

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
    const { data, isLoading } = useCheckAuthQuery();

    if (isLoading) {
        return null;
    }

    if (!data?.isValid) {
        return (
            <Navigate
                to='/login'
                replace
            />
        );
    }

    return <>{children}</>;
};
